import { ApiError } from '@lib/api';

/**
 * Whether a failed release read means "there is no such release page".
 *
 * Any 404, not only `RELEASE_NOT_FOUND`: unknown and archived ids both answer
 * that code, and a 404 is never worth a retry button. A 5xx, a refusal or a
 * transport failure is a different state and keeps the error panel.
 */
export function releaseNotFound(error: Error): boolean {
    return error instanceof ApiError && error.status === 404;
}
